<template>
  <b-row>
    <b-col
      v-if="method === 1 || method === 2"
      md="12"
    >
      <b-form-group
        label="Campaign Text"
        label-for="campaign-text"
        :description="`Remaining Char: ${remainingCount1} Char`"
      >
        <validation-provider
          #default="{ errors }"
          name="campaign text"
          rules="required|max130"
        >
          <b-form-textarea
            id="campaign-text"
            v-model="content.campaign_text_frame_1"
            placeholder="Campaign Text"
            rows="3"
            :state="errors.length > 0 ? false:null"
            @keyup="countdown1"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <b-col
      v-if="method === 2"
      md="12"
    >
      <b-form-group
        label="Action Link"
        label-for="action-link"
      >
        <validation-provider
          #default="{ errors }"
          name="action link"
          rules="required"
        >
          <b-form-input
            id="action-link"
            v-model="content.action_link"
            placeholder="domain.com/xxxxx"
            rows="3"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-col>
    <div
      v-if="method === 3 || method === 4"
      class="d-flex flex-wrap w-100"
    >
      <b-col md="12">
        <b-form-group
          label="Campaign Text Frame 1"
          label-for="campaign-text-frame-1"
          :description="`Remaining Char: ${remainingCount1} Char`"
        >
          <validation-provider
            #default="{ errors }"
            name="campaign text frame 1"
            rules="required|max130"
          >
            <b-form-textarea
              id="campaign-text-frame-1"
              v-model="content.campaign_text_frame_1"
              placeholder="Add Campaign Text"
              rows="3"
              :state="errors.length > 0 ? false:null"
              @keyup="countdown1"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group
          label="Campaign Text Frame 2"
          label-for="campaign-text-frame-2"
          :description="`Remaining Char: ${remainingCount2} Char`"
        >
          <validation-provider
            #default="{ errors }"
            name="campaign text frame 2"
            rules="required|max130"
          >
            <b-form-textarea
              id="campaign-text-frame-2"
              v-model="content.campaign_text_frame_2"
              placeholder="Add Campaign Text"
              rows="3"
              :state="errors.length > 0 ? false:null"
              @keyup="countdown2"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- <b-row> -->
      <b-col md="6">
        <b-form-group
          label="Product Registry Key"
          label-for="product-registry-key"
        >
          <validation-provider
            #default="{ errors }"
            name="product registry key"
            rules="required"
          >
            <b-form-input
              id="product-registry-key"
              v-model="content.product_registry_key"
              placeholder="Type your product registry key"
              rows="3"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
          label="Shortcode"
          label-for="shortcode"
        >
          <validation-provider
            #default="{ errors }"
            name="shortcode"
            rules="required|regex:^([0-9]+)$"
          >
            <b-form-input
              id="shortcode"
              v-model="content.shortcode"
              placeholder="97XXX"
              rows="3"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- </b-row> -->
    </div>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BFormInput,
} from 'bootstrap-vue'
import { ValidationProvider, extend } from 'vee-validate'

extend('max130', value => {
  if (value.length <= 130) {
    return true
  }
  return 'The {_field_} field must be max 130 char'
})

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    ValidationProvider,
    BFormTextarea,
    BFormInput,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    method: Number,
  },
  data() {
    return {
      content: {
        action_link: '',
        campaign_text_frame_1: '',
        campaign_text_frame_2: '',
        product_registry_key: '',
        shortcode: '',
      },
      maxCount1: 130,
      remainingCount1: 130,
      maxCount2: 130,
      remainingCount2: 130,
    }
  },
  methods: {
    setContent() {
      this.$store.state.campaign.formCampaign.content = this.content
    },
    countdown1() {
      this.remainingCount1 = Math.max(0, this.maxCount1 - this.content.campaign_text_frame_1.length)
    },
    countdown2() {
      this.remainingCount2 = Math.max(0, this.maxCount2 - this.content.campaign_text_frame_2.length)
    },
  },
}
</script>

<style scoped>
</style>
